import styled from "styled-components";
export const BaseGrid = styled.div `
  display: grid;
  ${props => props.$padding && `padding: ${props.$padding};`}
  ${props => props.$column_gap && `column-gap: ${props.$column_gap};`}
  ${props => props.$row_gap && `row-gap: ${props.$row_gap};`}
`;
